/**
 * @module tree/fragment
 */

/**
 * @typedef {String|Number|DocumentFragment|Element|Text} Content
 */

import defaults from '../selectors/defaults.js'

/**
 * Returns a new fragment based on the provided contents
 * @param {Content[]} contents
 * @param {Document} document
 * @returns {DocumentFragment}
 */
export default (
  [
    ...contents
  ] = [],
  document = defaults.document
) => {
  const fragment = document.createDocumentFragment()

  for (let content of contents.flat(Infinity)) {
    if (typeof content !== 'object') {
      content = document.createTextNode(`${content}`)
    }

    fragment.appendChild(content)
  }

  return fragment
}
